import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/store';
import type { RoleType } from '@/store/modules/user/types';

export default function usePermission() {
  const userStore = useUserStore();

  return {
    accessRouter(route: RouteLocationNormalized | RouteRecordRaw) {
      return (
        userStore.user.roles.includes('admin') ||
        route.meta?.notAuth ||
        !route.meta?.roles ||
        route.meta?.roles?.includes('*') ||
        userStore.user.roles.some(role => route.meta?.roles?.includes(role))
      );
    },

    findFirstPermissionRoute(_routers: RouteRecordRaw[], roles: RoleType[] = []) {
      // 辅助函数：检查节点是否有权限
      const hasPermission = (route: RouteRecordRaw | undefined) => {
        return route && (
          route.meta?.notAuth ||
          !route.meta?.roles ||
          route.meta?.roles?.includes('*') ||
          route.meta?.roles?.find((el) => roles.includes(el as RoleType))
        );
      };

      // const cloneRouters = [..._routers];
      let lastPermissionRoute: { path: string } | null = null;

      // 使用一个队列来存储待处理的路由节点及其路径
      const queue: { route: RouteRecordRaw, path: string }[] = _routers.map(route => ({ route, path: route.path }));

      while (queue.length) {
        const { route, path } = queue.shift()!;

        // 检查当前节点是否有权限
        if (hasPermission(route)) {
          lastPermissionRoute = { path };

          // 如果有子节点，将它们添加到队列中继续检查
          if (route.children?.length) {
            route.children.forEach(child => {
              // 将子节点的路径拼接到当前路径后面
              queue.push({ route: child, path: `${path}` });
            });
          } else {
            // 如果没有子节点且有权限，说明找到了最深层的有权限节点
            return { path };
          }
        }
      }

      // 如果遍历完所有节点后还没有找到最深层的有权限节点，
      // 返回最后一个有权限的节点，如果没有任何节点有权限则返回 null
      return lastPermissionRoute;
    },
    // You can add any rules you want
  };
}
